import { createGlobalStyle, keyframes } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    vertical-align: baseline;
    border: 0;
  }

  html, body, #root {
    background-color: var(--background);
    box-sizing: border-box;

  }

  body {
    font-family: 'Mulish', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
    display: block;
}

ol, ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

  code {
    font-family: 'Mulish', sans-serif;
  }

  a:link,
  a:visited,
  a:active,
  a:hover {
    text-decoration: none;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  /* Edge password eye button */
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  /* Chrome autofill background */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px var(--background) inset !important;
    /* -webkit-box-shadow: 0 0 0 30px var(--background) inset !important; */
  }

  /* Global classes */
  .slick-dots li.slick-active button::before {
    color: var(--theme-primary) !important;
    font-size: 13px;
  }

  .slick-dots li button::before {
    color: var(--theme-primary) !important;
    font-size: 8px;
  }

  .slick-dots2 li.slick-active button::before {
    color: var(--theme-secondary) !important;
    opacity: 1 !important;
    font-size: 13px;
  }

  .slick-dots2 li button::before {
    color: var(--theme-secondary) !important;
    font-size: 8px;
  }

  .slick-dots3 li.slick-active button::before {
    color: #000 !important;
    opacity: 1 !important;
    font-size: 13px;
  }

  .slick-dots3 li button::before {
    color: #000 !important;
    font-size: 8px;
  }

  .border {
    background: linear-gradient(
      90deg,
      rgba(192, 204, 218, 0.1) 0%,
      rgba(192, 204, 218, 0.6) 50.38%,
      rgba(192, 204, 218, 0.1) 100%
    );
    height: 1px;
    width: 100% !important;
  }

  :root {
    /* Theme Colors */

    --theme-primary: #BE9137;
    --theme-primary-light: #EBB750;
    --theme-secondary: #FFFFFF;
    --theme-tertiary: #151515;
    --theme-green: #129737;
    --light-gray: #9C9C9C;

    --text-primary: #7D7987;
    --text-secondary: #151515;
    --text-tertiary: #858585;
    --text-light: #F0F0F0;
    --text-dark: #4F4F4F;
    --text-disabled: #C4C4C4;


    --background: #FFFFFF;
    --background-hover: #FAFAFA;
    --carousel-primary-background: #FFFFFF;
    --carousel-hover-background: linear-gradient(175.68deg, #FFF0D2 -10.48%, #FFECC5 92.66%);
    --carousel-secondary-background: linear-gradient(180deg, #000000 0%, #171719 39.2%);
    --carousel-button-background: #FFFFFF;
    --footer-background: #151515;
    --background-table: #fdfdff;
    --border-color-table: #ebebeb;
    
    --background-button: #FFFFFF;
    --background-button-hover: #F0F0F0;

    --border-light: #F0F0F0;
    --border-dark: #D4D4D4;
    --border-disabled: #C4C4C4;

    --button: #FFFFFF;
    --button-hover: #4F4F4F;
    --button-disabled: #C4C4C4;

    --info: #00A0FF;
    --success: #0DA60A;
    --warning: #F0AF1A; /* #FFC400, #FFC107, #F0AF1A */
    --danger: #FF3B30;
    --black: #000;
    --dark: #333333;

    --shadow: rgba(0, 0, 0, 0.9);
    --shadow-light: rgba(48, 48, 48, 0.55);
    --modal-background: rgba(57, 50, 54, 0.72);


    /* Other config */

    --border-radius-sm: 3px;
    --border-radius-md: 5px;
    --border-radius-lg: 10px;

    --font-size-ssm: 0.75rem;
    --font-size-sm: 0.85rem;
    --font-size-md: 1rem;
    --font-size-lg: 1.2rem;
    --font-size-xlg: 1.25rem;
    --font-size-xl: 1.5rem;
    --font-size-ss: 0.75rem;


    --z-index-header: 1000;
    --z-index-modal: 1002;
    --z-index-modal-backdrop: 1001;
  }
`

// Transitions
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`

export const slideDown = keyframes`
  from {
    transform: translate(0, -50px);
    opacity: 0;
  }

  to {
    transform: translate(0, 0px);
    opacity: 1;
  }
`

export const slideUp = keyframes`
  from {
    transform: translate(0, 0px);
    opacity: 1;
  }

  to {
    transform: translate(0, -50px);
    opacity: 0;
  }
`
